export default __webpack_public_path__ + "static/media/pg-13.9ed47095.jpg";